/* eslint-disable camelcase */
export default class Estimate {
  created_at = '';
  created_by_user = '';
  estimate_items = [];
  id = 0;
  memo = '';
  partner = {};
  sales_rep = {};
  updated_by_user = '';
  partner_store={};
  partner_store_id = 0;
  sales_rep_id = 0;
  is_editable = true;
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/Estimate.js